(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-about-story"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {

    // 1) 스크롤 등장 텍스트 애니메이션
    var observerOptions = { root: null, rootMargin: '0px', threshold: 0.2 };
    var revealObserver = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('show');
          obs.unobserve(entry.target);
        }
      });
    }, observerOptions);

    document.querySelectorAll('.oatae-custom-wrap .animate-text').forEach(function (el) {
      revealObserver.observe(el);
    });

    // 2) 자동 슬라이더 (섹션 안에 여러 개 있어도 각각 독립 동작하도록 전체 순회)
    document.querySelectorAll('[data-auto-slider]').forEach(function (sliderWrapper) {
      var slides = sliderWrapper.querySelectorAll('.about-slider-slide');
      var realTotal = slides.length;

      if (realTotal > 1) {
        // 첫 번째 슬라이드를 복제해서 맨 뒤에 붙임 -> 마지막에서 처음으로 돌아갈 때 끊김 없이 자연스러운 무한루프
        var firstClone = slides[0].cloneNode(true);
        sliderWrapper.appendChild(firstClone);

        var totalSlides = realTotal + 1; // 복제본 포함
        var currentSlide = 0;

        setInterval(function () {
          currentSlide++;
          sliderWrapper.style.transition = 'transform 0.8s ease-in-out';
          sliderWrapper.style.transform = 'translateX(-' + (currentSlide * 100) + '%)';

          // 복제본(마지막)에 도달하면, 전환이 끝난 뒤 애니메이션 없이 진짜 1번으로 순간 이동
          // 복제본과 1번이 똑같이 생겨서 이 순간이동은 눈에 보이지 않음
          if (currentSlide === totalSlides - 1) {
            setTimeout(function () {
              sliderWrapper.style.transition = 'none';
              currentSlide = 0;
              sliderWrapper.style.transform = 'translateX(0%)';
            }, 800);
          }
        }, 3000);
      }
    });

    // 3) 좌우분할 슬라이더 (진행바 방식, split_slider 블록)
    document.querySelectorAll('[data-split-slider]').forEach(function (slider) {
      var slides = slider.querySelectorAll('.about-split__slide');
      var progressWrap = slider.closest('.about-split__media').querySelector('[data-split-progress]');
      var bars = progressWrap ? progressWrap.querySelectorAll('.about-split__bar-fill') : [];
      var current = 0;

      if (slides.length <= 1) return;

      function goTo(index) {
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
        bars.forEach(function (bar, i) {
          bar.classList.remove('is-filling', 'is-done');
          if (i < index) bar.classList.add('is-done');
        });
        if (bars[index]) {
          // 리플로우 강제 -> 애니메이션 재시작 보장
          void bars[index].offsetWidth;
          bars[index].classList.add('is-filling');
        }
      }

      goTo(0);

      setInterval(function () {
        current = (current + 1) % slides.length;
        goTo(current);
      }, 4000);
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-lookbook-article"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-slider-prev]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = document.getElementById(btn.getAttribute('data-slider-prev'));
        if (target) target.scrollBy({ left: -target.clientWidth * 0.6, behavior: 'smooth' });
      });
    });
    document.querySelectorAll('[data-slider-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = document.getElementById(btn.getAttribute('data-slider-next'));
        if (target) target.scrollBy({ left: target.clientWidth * 0.6, behavior: 'smooth' });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
